import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

export class GetCaptchaStatusFormUseCase extends UseCase {
  constructor({getCaptchaStatusFormService}) {
    super()
    this._getCaptchaStatusFormService = getCaptchaStatusFormService
  }

  @inlineError
  async execute({pageName, context}) {
    const [getCaptchaStatusFormServiceError, getCaptchaStatusFormServiceResponse] =
      await this._getCaptchaStatusFormService.execute({
        pageName,
        context
      })

    if (getCaptchaStatusFormServiceError) return Promise.reject(getCaptchaStatusFormServiceError)

    return getCaptchaStatusFormServiceResponse.toJSON()
  }
}
